<template>
  <div class="app-activate-auto-top-up">
    <div class="text"><slot name="txtBeforeAutoTopUp"></slot></div>
    <auto-top-up
      v-if="topUp_.active"
      :top-up="topUp_"
      :trigger.sync="topUp_.trigger"
      :amount.sync="topUp_.amount"
      :monthly-value="monthlyValue"
    >
    </auto-top-up>
    <div class="button-wrapper">
      <button @click="showModal = true" v-if="!topUp_.active" class="button button--primary full-width" :disabled="loading">
        Automatische Aufladung aktivieren
      </button>
      <button v-if="topUp_.active" @click="showModal = true" class="button button--secondary" :disabled="loading">
        Aufladeart ändern
      </button>
      <button v-if="topUp_.active" @click="activate()" class="button button--primary text-sm" type="button" :disabled="loading">
        <slot name="btnNext">aktivieren</slot>
      </button>
    </div>

    <CustomModal
      :visible="showModal"
      @close="close"
      @prev="close"
      @next="activate"
      :showPrev="true"
      :showNext="true"
      :disable-next="loading"
      :disable-prev="loading"
    >
      <template slot="header">
        <slot name="header">Automatische Aufladung</slot>
      </template>
      <template slot="default">
        <slot name="default">
          <auto-top-up
            :top-up="topUp_"
            :trigger.sync="topUp_.trigger"
            :amount.sync="topUp_.amount"
            :monthly-value="monthlyValue"
            @update-top-up="updateTopUp"
            :inside-modal="true"
          >
          </auto-top-up>
        </slot>
      </template>

      <template slot="btnNextTxt">
        <slot name="btnNextTxt">Auswahl aktivieren</slot>
      </template>
    </CustomModal>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import processSteps from '../../../../../mixins/processSteps'
import isValid from '../../../../../mixins/isValid'
import { required, numeric } from 'vuelidate/lib/validators'
import { mapActions, mapMutations } from 'vuex'
import { stepName as nextProcessStep } from '@/components/generic/Success2.vue'
import syncProperty from '@/mixins/syncProperty'
import CustomModal from '@/components/generic/CustomModal.vue'
import AutoTopUp from '../AutoTopUp.vue'

export const stepName = 'activate'
export default {
  name: 'ActivateAutoTopUp',
  data() {
    return {
      loading: false,
      showModal: false,
      initialTopUp: {}
    }
  },
  mounted() {
    this.initialTopUp = Object.assign(this.initialTopUp, this.topUp)
  },
  computed: {
    splittedTopUp: {
      get: function() {
        if (this.topUp_.type === 'monthly') {
          return {
            type: this.topUp_.type,
            trigger: this.topUp_.trigger
          }
        }
        return {
          type: this.topUp_.type
        }
      },
      set: function(value) {
        this.topUp_.type = value.type
        if (value.type === 'monthly') {
          this.topUp_.trigger = value.trigger
        }
      }
    }
  },
  mixins: [syncProperty('topUp', 'topUp_'), validationMixin, isValid, processSteps(stepName, stepName, nextProcessStep)],
  validations() {
    return {
      topUp: {
        amount: {
          required,
          numeric
        },
        trigger: {
          required,
          numeric
        },
        type: {
          required
        }
      }
    }
  },
  components: { CustomModal, AutoTopUp },
  methods: {
    updateTopUp(value) {
      this.topUp_.type = value?.type || null
      if (!value) return

      this.topUp_.trigger = value.trigger
      this.topUp_.amount = value.amount
    },
    close() {
      this.updateTopUp(this.initialTopUp)
      this.showModal = false
    },
    activate() {
      if (this.loading) return
      this.loading = true

      if (this.topUp_.type === null) {
        this.deactivateTopUp()
      } else {
        this.changeAutoTopUp({
          topUpData: this.topUp_,
          nextStep: this.nextStep
        }).then(
          async () => {
            await this.confirmAutoTopUp()
            this.refreshQuery()
            this.showModal = false
            this.loading = false
          },
          () => {
            this.showModal = false
            this.loading = false
          }
        )
      }
    },
    deactivateTopUp() {
      this.deactivateAutoTopUp().then(
        () => {
          this.refreshQuery()
          this.loading = false
          this.showModal = false
        },
        () => {
          this.showModal = false
          this.loading = false
        }
      )
    },
    refreshQuery() {
      this.$emit('refresh-query')
    },
    ...mapActions('topUp', ['deactivateAutoTopUp']),
    ...mapActions('topUp', ['changeAutoTopUp']),
    ...mapActions('topUp', ['confirmAutoTopUp']),
    ...mapMutations('topUp', ['setActivationView'])
  },
  props: ['monthlyValue']
}
</script>
